// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"3c3c7284","546":"1d358167"}[chunkId] + ".chunk.js";
};